import { Box, Page, Text } from '@shopify/polaris';
import { Link } from 'react-router';
import './Breadcrumb.css';

const Breadcrumb = ({ items }) => {
    return (
        <Page fullWidth className="breadcrumb-container">
            <Box paddingBlockStart="2" paddingBlockEnd="2">
                <Box className="breadcrumb-content">
                    <Box className="breadcrumb-items">
                        {items.map((item, index) => {
                            const isLast = index === items.length - 1;
                            const content = (
                                <Text variant="bodyMd" as="span">
                                    {item.label}
                                </Text>
                            );

                            return (
                                <Box key={item.label} className="breadcrumb-item">
                                    {isLast && !item.url ? (
                                        <span className="breadcrumb-current">{content}</span>
                                    ) : (
                                        <>
                                            <Link to={item.url} className="breadcrumb-link">
                                                {content}
                                            </Link>
                                            {items.length > 1 && <span className="breadcrumb-separator">/</span>}
                                        </>
                                    )}
                                </Box>
                            );
                        })}
                    </Box>
                </Box>
            </Box>
        </Page>
    );
};

export default Breadcrumb;
